export const DEFAULT_PROFILE_IMAGE_PATH = '/images/Video-Thumbnail.svg'
